/**
 * Shared constants for sensor-device lists (PD-13926). Status values mirror
 * the SensorStatus enum (online/offline/error/maintenance) — the device-level
 * status is bubbled up from ingestion / the health cron.
 */
export const SENSOR_DEVICE_STATUS_VALUE_MAPPING = [
	{
		value: 'online',
		label: 'Online',
		color: { type: 'success' },
	},
	{
		value: 'offline',
		label: 'Offline',
		color: { type: 'danger' },
	},
	{
		value: 'error',
		label: 'Error',
		color: { type: 'danger' },
	},
	{
		value: 'maintenance',
		label: 'Maintenance',
		color: { type: 'warning' },
	},
];
